import { Component, OnInit } from '@angular/core';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-partner-name',
	templateUrl: './partner-name.component.html',
	styleUrls: ['./partner-name.component.css']
})
export class PartnerNameComponent implements OnInit {
	public partnerName: string;

	constructor(private analyticsDataModel: AnalyticsDataModel) {}

	ngOnInit() {
		this.partnerName = this.analyticsDataModel.partner.partnerName;
	}
}
